function customAddToCartJS(variantID, qty = 1) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch("/cart.js").then(response => response.json()).then(cart => {
                const existingItem = cart.items.find(item => item.variant_id === variantID);
                if (existingItem && existingItem.quantity >= 1) console.log("Product already in cart with quantity 1 or more. No further increase allowed."), resolve();
                else {
                    var xhr = new XMLHttpRequest,
                        url = "/cart/add.js";
                    xhr.open("POST", url, !0), xhr.setRequestHeader("Content-Type", "application/json"), xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4)
                            if (xhr.status === 200) {
                                var parsedState = JSON.parse(xhr.responseText);
                                document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                                    bubbles: !0
                                })), console.log("Cart Refreshed from add to cart functoin"), resolve()
                            } else reject(xhr.statusText)
                    };
                    var data = JSON.stringify({
                        quantity: qty,
                        id: variantID
                    });
                    xhr.send(data)
                }
            }).catch(error => reject(error))
        }, 1e3)
    })
}


function removeFromCartJS(variantID) {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest,
            url = "/cart/change.js";
        xhr.open("POST", url, !0), xhr.setRequestHeader("Content-Type", "application/json"), xhr.onreadystatechange = function() {
            if (xhr.readyState === 4)
                if (xhr.status === 200) {
                    var parsedState = JSON.parse(xhr.responseText);
                    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
                        bubbles: !0
                    })), console.log("Cart Refreshed from remove functoin"), resolve()
                } else reject(xhr.statusText)
        };
        var data = JSON.stringify({
            quantity: 0,
            id: variantID,
        });
        xhr.send(data)
    })
}
const addOnData = {
    "loss-protection": {
        title: "Loss Protection",
        price: "$30.00",
        image: "https://cdn.shopify.com/s/files/1/0645/4385/0718/files/Loss_Protection_eb4a3eff-c960-4419-a6f5-b8e1750a5432.svg?v=1789017206",
        description: "Safeguard your order from loss during shipping.",
        pid: "48202194452702"
    },
    "damage-protection": {
        title: "Damage Protection",
        price: "$100.00",
        image: "https://cdn.shopify.com/s/files/1/0645/4385/0718/files/Damage_Protection_b44ec73a-f091-40aa-baa8-43bbf1e43fdf.svg?v=1789017207",
        description: "Protect your order from shipping damage.",
        pid: "48202190520542"
    },
    "theft-protection": {
        title: "Theft Protection",
        price: "$20.00",
        image: "https://cdn.shopify.com/s/files/1/0645/4385/0718/files/Theft_Protection_3f2c7f1b-c000-4645-be36-d024a9a612eb.svg?v=1789017207",
        description: "Protect your purchase from theft during shipping.",
        pid: "48202198057182"
    }
};

// 👉 Bind refresh logic on click
const bindCartRefreshEvent = (btn) => {
    btn.addEventListener("click", () => {
        console.log("update clicked");
        setTimeout(() => {
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
        }, 500);
    });
};

// 👉 Handle icon click and update UI
const addEventToEachIcon = () => {
    // Remove any previous global listener (optional but safe)
    document.removeEventListener("click", addonIconClickHandler);
    document.addEventListener("click", addonIconClickHandler);
};

const addonIconClickHandler = async (event) => {
    const icon = event.target.closest(".addon-icon");
    if (!icon) return;

    event.preventDefault();

    const addonType = icon.getAttribute("data-addontype");
    const addonInfo = addOnData[addonType];

    if (!addonInfo) return;

    // Update UI
    document.querySelector(".addon-title").textContent = addonInfo.title;
    document.querySelector(".addon-price").textContent = addonInfo.price;
    document.querySelector(".addon-description").textContent = addonInfo.description;
    document.querySelector(".addon-image").src = addonInfo.image;

    // ✅ Only one call to /cart.js now
    const cart = await fetch("/cart.js").then(res => res.json());
    const existingItem = cart.items.find(item => item.variant_id == addonInfo.pid);

    const addBtn = document.querySelector(".addon-add-to-cart");
    const removeBtn = document.querySelector(".addon-remove-from-cart");

    addBtn.setAttribute("data-pid", addonInfo.pid);
    removeBtn.setAttribute("data-pid", addonInfo.pid);

    if (existingItem) {
        addBtn.classList.add("hidden");
        removeBtn.classList.remove("hidden");
    } else {
        addBtn.classList.remove("hidden");
        removeBtn.classList.add("hidden");
    }

    document.getElementById("addon-info-panel").classList.add("active");
};




// 👉 Main handler that rebinds click events
const popUpHandler = () => {
    const cartRemoveBtns = document.querySelectorAll(".mini-cart__quantity-remove");
    const qtyBtns = document.querySelectorAll(".quantity-selector__button");

    cartRemoveBtns.forEach(bindCartRefreshEvent);
    qtyBtns.forEach(bindCartRefreshEvent);

    addEventToEachIcon();

    // Panel close
    document.addEventListener("click", e => {
        const panel = document.getElementById("addon-info-panel");
        const clickedInsidePanel = panel.contains(e.target);
        const clickedOnIcon = e.target.classList.contains("addon-icon");

        if (!clickedInsidePanel && !clickedOnIcon) {
            panel.classList.remove("active");
        }
    });
};

// 👉 Bind add-to-cart button
const addButtonFunctionality = () => {
    const oldBtn = document.querySelector(".addon-add-to-cart");
    if (!oldBtn) return;

    const newBtn = oldBtn.cloneNode(true);
    oldBtn.parentNode.replaceChild(newBtn, oldBtn);

    newBtn.addEventListener("click", async event => {
        event.preventDefault();

        const pid = newBtn.dataset.pid;
        if (!pid) return;

        //newBtn.disabled = true;
        //newBtn.style.display = "none";

        console.log("Adding product...");
        await customAddToCartJS(pid);
        console.log("Product added.");

        const relatedIcon = document.querySelector(`.addon-icon[data-productid="${pid}"]`);
        if (relatedIcon) relatedIcon.classList.add("added");

        // ✅ Refresh cart UI
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }, { once: true });
};

// 👉 Call after cart updates
const handleCartUIUpdate = () => {
    setTimeout(() => {
        popUpHandler();
        addButtonFunctionality();
    }, 1000);
};

// 👉 Main events
document.addEventListener("cart:refresh", handleCartUIUpdate);
document.addEventListener("product:added", handleCartUIUpdate);

// Trigger on page load
document.addEventListener("DOMContentLoaded", () => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
});


    const addClassToElements = () => {
        fetch("/cart.js").then(response => response.json()).then(cart => {
            cart.items.forEach(item => {
                document.querySelector(`.addon-icon[data-productid="${item.variant_id}"]`)?.classList?.add("added")
            })
        })
    },
    cartManager = () => {
        setTimeout(() => {
          const damageProtection = document.querySelector(".damage-protection"),
                shippingProtection = document.querySelector(".theft-protection"),
                lossProtection = document.querySelector(".loss-protection"),
                addOns = document.querySelectorAll(".addon-icon"),
                cartLines = document.querySelectorAll(".mini-cart__line-item"),
                addOnProductLoss = Object.values(cartLines).filter(item => item.id.includes(damageProtection.dataset.productid) || item.id.includes(shippingProtection.dataset.productid) || item.id.includes(lossProtection.dataset.productid));
            async function addAllProducts() {
                for (const [index, addOn] of addOns.entries()) await customAddToCartJS(+addOn.dataset.productid, 1), console.log("added " + index)
            }
            async function removeAllProducts() {
                for (const addOn of addOnProductLoss) await removeFromCartJS(addOn.dataset.itemkey), console.log(addOn.dataset.itemkey)
            }
            addOnProductLoss.length === cartLines.length ? removeAllProducts() : addOnProductLoss.length == 0 && cartLines.length <= 1 && (console.log("All products Added to cart"), addAllProducts())
        }, 1e3), document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
            bubbles: !0
        }))
    },
    cartRefreshManager = () => {
        setTimeout(() => {
            const damageProtection = document.querySelector(".damage-protection"),
                shippingProtection = document.querySelector(".theft-protection"),
                lossProtection = document.querySelector(".loss-protection"),
                cartLines = document.querySelectorAll(".mini-cart__line-item"),
                addOnProductLoss = Object.values(cartLines).filter(item => item.id.includes(damageProtection.dataset.productid) || item.id.includes(shippingProtection.dataset.productid) || item.id.includes(lossProtection.dataset.productid));
            async function removeAllProducts() {
                for (const addOn of addOnProductLoss) await removeFromCartJS(addOn?.dataset?.itemkey), console.log("Removed item productid: " + addOn?.dataset?.itemkey)
            }

            console.log("Removal Condition "), console.log(addOnProductLoss.length === cartLines.length), addOnProductLoss.length === cartLines.length && (console.log("Removal Condition Matched"), removeAllProducts())
        }, 1000)
    };

document.addEventListener("product:added", cartManager), document.addEventListener("cart:refresh", cartRefreshManager), document.addEventListener("cart:refresh", () => {
    setTimeout(() => {
        popUpHandler(), addClassToElements(), document.querySelectorAll(".mini-cart__line-item").length > 0 && (addRemoveFunctionality(), addButtonFunctionality())
    }, 1000)
}), document.addEventListener("product:added", () => {
    setTimeout(() => {
        popUpHandler(), document.querySelectorAll(".mini-cart__line-item").length > 0 && (addRemoveFunctionality(), addClassToElements()), addButtonFunctionality()
    }, 1000)
}), document.addEventListener("DOMContentLoaded", () => {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
        bubbles: !0
    }))
});


document.addEventListener("click", async (event) => {
    // Use event delegation for dynamic elements
    const removeBtn = event.target.closest(".addon-remove-from-cart");
    if (!removeBtn) return;

    event.preventDefault();

    const productId = removeBtn.dataset.pid;

    if (!productId) {
        console.error("No product ID found.");
        return;
    }

    // ✅ AJAX remove call
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: productId,
                quantity: 0
            })
        });

        if (!response.ok) throw new Error("Failed to remove item");

        const cartData = await response.json();

        // ✅ Refresh cart UI
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));

    } catch (error) {
        console.error("Error removing item from cart:", error);
    }
});

	